module.exports = __webpack_public_path__ + "static/media/ipad-profile-mockup.b97918ad.png";